

import * as React from 'react';
import * as ReactDom from 'react-dom';
import { headerStyle, headerStyleGrid, headerStyleColumn} from "./AppHeader.Style";

export const AppHeader = () => {

 

return  (
        <div style={headerStyleGrid()}>
                <div style={headerStyleColumn()}>
                 Cohorts Reader   
                </div>  
        </div>  
)
}


